import { render, staticRenderFns } from "./EmailMagazineCompletedDialog.vue?vue&type=template&id=84318244&scoped=true"
import script from "./EmailMagazineCompletedDialog.vue?vue&type=script&lang=ts"
export * from "./EmailMagazineCompletedDialog.vue?vue&type=script&lang=ts"
import style0 from "./EmailMagazineCompletedDialog.vue?vue&type=style&index=0&id=84318244&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84318244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84318244')) {
      api.createRecord('84318244', component.options)
    } else {
      api.reload('84318244', component.options)
    }
    module.hot.accept("./EmailMagazineCompletedDialog.vue?vue&type=template&id=84318244&scoped=true", function () {
      api.rerender('84318244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/EmailMagazineCompletedDialog.vue"
export default component.exports